import { useCallback } from "react";
import api from "../config/api/axiosConfig";

export const useFontenehusApi = () => {
  // ✅ Get all Fontenehus
  const getAllFontenehus = useCallback(async () => {
    const response = await api.get("/fontenehus");
    return response;
  }, []);

  const getFontenehusById = useCallback(async (fontenehusId: number) => {
    const response = await api.get("/fontenehus/" + fontenehusId);
    return response;
  }, []);

  // ✅ Update existing Fontenehus
  const updateFontenehus = useCallback(
    async (
      fontenehusId: number,
      data: {
        name?: string;
        fontenehusCode?: string;
        deleteSuggestionDays: number;
      },
    ) => {
      const response = await api.put("/fontenehus/" + fontenehusId, data);
      return response;
    },
    [],
  );

  // ✅ Create new Fontenehus
  const createFontenehus = useCallback(async (name: string) => {
    const response = await api.post("/fontenehus", { name });
    return response;
  }, []);

  // ✅ Delete Fontenehus
  const deleteFontenehus = useCallback(async (id: number) => {
    const response = await api.delete(`/fontenehus/${id}`);
    return response;
  }, []);

  // ✅ Generate new Fontenehus code
  const generateFontenehusCode = useCallback(async (id: number) => {
    const response = await api.put(`/fontenehus/${id}/generate-code`);
    return response;
  }, []);

  return {
    getAllFontenehus,
    createFontenehus,
    deleteFontenehus,
    getFontenehusById,
    updateFontenehus,
    generateFontenehusCode,
  };
};
